
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import OtherAssetsFsSurvey from "./OtherAssetsFSSurvey.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";

import PageBase from "../../PageBase.vue";

@Component({
    components:{
      OtherAssetsFsSurvey,
      PageBase
    }
})
export default class OtherAssetsFS extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void
    

    @Watch('otherAssetsData')
    otherAssetsDataChange(newVal) 
    {
        this.UpdateStepResultData({step:this.step, data: {otherAssetsFSSurvey: this.getOtherAssetsResults()}})  
    }

    currentStep =0;
    currentPage =0;
    showTable = true;
    otherAssetsData = [];
    anyRowToBeEdited = null;
    editId = null;
 
    created() {
        if (this.step.result?.otherAssetsFSSurvey?.data) {
            this.otherAssetsData = this.step.result.otherAssetsFSSurvey.data;
        }
    }

    mounted(){        
        const progress = this.otherAssetsData?.length>0? 100 : 50;            
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
        Vue.nextTick(()=>{
            const el = document.getElementById('other-assets-fs-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {
        this.showTable = value;
    }

    public populateSurveyData(otherAssetsValue) {
        const currentIndexValue = this.otherAssetsData?.length > 0 ? this.otherAssetsData[this.otherAssetsData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newOtherAssets = { ...otherAssetsValue, id };

        this.otherAssetsData = this.otherAssetsData? [...this.otherAssetsData, newOtherAssets]:[newOtherAssets];

        this.showTable = true; 
    }

    public deleteRow(rowToBeDeleted) {
        this.otherAssetsData = this.otherAssetsData.filter(data => {
            return data.id !== rowToBeDeleted;
        });
    }

    public editRow(editedRow) {
        this.otherAssetsData = this.otherAssetsData.map(data => {
            return data.id == this.editId ? editedRow : data;
        });
        this.showTable = true;
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    public isDisableNext() {    
        if(this.otherAssetsData?.length > 0) return false;
        else return true;
    }    

    beforeDestroy() {
        const progress = this.otherAssetsData?.length>0? 100 : 50;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
        this.UpdateStepResultData({step:this.step, data:{otherAssetsFSSurvey: this.getOtherAssetsResults()}})       
    }
   
    public getOtherAssetsResults(){
        const questionResults: {name:string; value: string[]; title:string; inputType:string}[] =[];
        if(this.otherAssetsData)
            for(const otherAssets of this.otherAssetsData)
            {
                questionResults.push({name:'otherAssetsFSSurvey', value: this.getOtherAssetsInfo(otherAssets), title:'Other assets '+otherAssets.id +' Information', inputType:''})
            }

        return {data: this.otherAssetsData, questions:questionResults, pageName:'Other assets', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getOtherAssetsInfo(otherAssets){        
        const resultString: string[] = [];
        resultString.push(Vue.filter('styleTitle')("Description: ")+otherAssets.otherAssetsDescription);
        resultString.push(Vue.filter('styleTitle')("Value: ")+otherAssets.otherAssetsValue);
        return resultString
    }

}
